import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { EmailService } from 'src/app/services/email.service';
import { LoginService } from 'src/app/services/login.service';
import { UsuariosService } from 'src/app/services/usuarios.service';

@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styleUrls: ['./recuperar-password.component.scss']
})
export class RecuperarPasswordComponent implements OnInit {

  public email: any;
  public password: any;
  public invalidUser: boolean;
  hide = true;
  datosUser: any={};

  constructor(private formBuilder: FormBuilder, private apollo: Apollo, private router: Router, private userService: UsuariosService, private emailService: EmailService, public confirmacionService: ConfirmacionService) {
    this.invalidUser = false;
    this.buildForm();
  }

  ngOnInit(): void {
  }

  private buildForm(){
    this.datosUser = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  handleLogin(){
    this.apollo.watchQuery<any>({
      query: this.userService.getAllUsuarios(),
      
    })
      .valueChanges
      .subscribe(({data}) => {
        
        this.email = this.datosUser.value.email
        const searchUser = data.users.filter((user:any)=> user.email == this.email)

        if (searchUser.length > 0) {
          this.password = this.generatePassword();
          this.updateUser(searchUser[0].id, this.password);
         
          const templateNuevoPassword = `<img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/contrasenaxtensa_55d6036257.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h1 style="color: #1F775A; font-weight:bolder; text-align:center">Hola de nuevo ${searchUser[0].email}, ha solicitado una nueva contraseña</h1>
        <div style="text-align:center; font-size: 1.2rem">
        <p>Esta es su nueva contraseña: ${this.password}</p>
        
        </div>
        </div>
        <div style="text-align:center; margin-top:50px">
        
        </div>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">`;
          this.emailService.send(searchUser[0].email, 'Nueva Contraseña', templateNuevoPassword)
          this.confirmacionService.openPopUp('¡Todo listo!','Hemos enviado una nueva contraseña a su correo, porfavor revise su bandeja de entrada')
        }else{
          this.confirmacionService.openPopUp('Error al recuperar contraseña','No hay ningún usuario registrado con ese mail, si lo desea puede registrarse en Xtensa Básica o Xtensa Ampliada')
        }
      }, (error) => {
        console.log('Error al lanzar la query', error);
      })
}

generatePassword() {
  let length = 8,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
  for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

updateUser(id:any, password:any){
  this.apollo.mutate({
  mutation: this.userService.updateUsuario(),
  variables: {
    "input": {
      "where": {
        "id": id
      },
      "data": {
        "password": password,
      }
    }    
  }
})
  .subscribe(({data, errors}) => {
   console.log(data);
   
  }, (error) => {
    console.log('aaaaa',error)
  })
}


}
